<template>
  <!-- 外层循环：遍历大的配置项 (tableDataList) -->
  <div v-for="(tableData, index) in tableDataList" :key="index" style="margin-bottom: 30px;">

    <!-- 标题区：依然显示大项的标题 -->
    <div style="font-size: 1em; font-weight: bold; margin-bottom: 10px; border-left: 4px solid #409EFF; padding-left: 10px;">
      表格参数提取 {{ index + 1 }}
    </div>

    <!-- 内层循环：遍历 tableData.res，它现在包含了多个表格的数据 -->
    <!-- subTableRows 代表一个具体表格的所有行数据 -->
    <div v-for="(subTableRows, subIndex) in tableData.res" :key="subIndex" style="margin-bottom: 20px; padding-left: 10px;">

      <!-- 每个子表格的操作栏 -->
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 5px;">
        <div style="font-size: 0.8em; color: #666;">
          子表 {{ subIndex + 1 }}
        </div>

        <div style="display: flex; align-items: center; justify-content: right;">
          <!-- Ref 需要组合 index 和 subIndex 才能唯一找到对应的 el-table -->
          <export-table-button size="small" style="border-radius: 15px;" :table="tableRefs[`${index}-${subIndex}`]"/>
          <copy-table-button size="small" style="border-radius: 15px;" :table="tableRefs[`${index}-${subIndex}`]"/>
        </div>
      </div>

      <!-- 表格渲染 -->
      <!-- :data 绑定的是当前的 subTableRows -->
      <el-table
          :data="subTableRows"
          :header-cell-style="{ color: 'black' }"
          style="width: 100%;"
          border
          :key="`${tableKey}-${index}-${subIndex}`"
          :ref="(el) => setTableRef(el, index, subIndex)"
      >
        <el-table-column type="index" label="序号" width="60" align="center"/>

        <!-- 列定义：依然使用父级 tableData.fields，因为字段定义没有变 -->
        <el-table-column
            v-for="field in tableData.fields.filter((fieldStr)=> fieldStr!=='sourceText' && fieldStr!=='Gerber层名')"
            :key="field"
            :prop="field"
            :label="field"
            align="center"
        >
          <template #default="{ row }">
            <span v-if="!row.isEditing">{{ row[field] }}</span>
            <el-input v-else v-model="row.editData[field]" size="small"/>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150" align="center">
          <template #default="{ row }">
            <div v-if="!row.isEditing">
              <el-button size="small" type="primary" link @click="handleEdit(row)">
                修改
              </el-button>
              <el-button size="small" type="primary" link @click="handleLocate(row)">
                定位
              </el-button>
            </div>
            <div v-else>
              <el-button size="small" type="success" @click="handleConfirm(row)">
                确认
              </el-button>
              <el-button size="small" @click="handleCancel(row)">
                取消
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-divider v-if="index < tableDataList.length - 1" />
  </div>
</template>

<script>
import CopyTableButton from "@/components/sub_component/copyTableButton.vue"
import ExportTableButton from "@/components/sub_component/exportTableButton.vue"

import {ElMessage} from 'element-plus';
import {mapState} from "vuex";
import store from "@/store";
import {locationByPathKeyword} from "@/components/file_process_js/utils";

export default {
  name: 'TableParamTable',
  components: {
    CopyTableButton,
    ExportTableButton
  },
  props: {
    fileInfo: {
      type: Object,
      required: true
    },
    positionKey: {type: String, required: true}
  },
  data() {
    return {
      // 变更：改为对象存储，key 为 "index-subIndex"
      tableRefs: {},
      tableDataList: [],
      lastFileInfoStatusCode: 0,
      tableKey: 0
    };
  },

  computed: {
    ...mapState(['checkListChangeSign']),
  },

  watch: {
    'fileInfo.position_params': {
      immediate: true,
      deep: false,
      handler(newVal) {
        this.refreshTable()
      }
    },

    checkListChangeSign(currentSign) {
      if (currentSign && this.lastFileInfoStatusCode !== this.fileInfo.status_code) {
        console.log("table start refresh");
        this.refreshTable()
      }
    }
  },

  methods: {
    // 变更：Ref 收集函数，使用组合键
    setTableRef(el, index, subIndex) {
      if (el) {
        this.tableRefs[`${index}-${subIndex}`] = el;
      }
    },

    refreshTable() {
      // 重置
      this.tableRefs = {};
      this.tableDataList = [];

      const position_params = this.fileInfo.position_params
      this.lastFileInfoStatusCode = this.fileInfo.status_code

      if (!position_params || !position_params[this.positionKey] || !position_params[this.positionKey].tableParams) {
        return;
      }

      const sourceParams = position_params[this.positionKey].tableParams;

      // 遍历每一个大项 (tableData)
      for (let i = 0; i < sourceParams.length; i++) {
        const item = sourceParams[i];

        // 数据处理逻辑升级：
        // item.res 是一个数组，里面包含了多个表格的数据（每个元素是 rows 数组）
        if (Array.isArray(item.res)) {
          // 遍历每一个子表格
          item.res.forEach(subTableRows => {
            // 确保 subTableRows 是数组才进行遍历处理
            if (Array.isArray(subTableRows)) {
              subTableRows.forEach(row => {
                // 处理 Gerber层名 逻辑
                if (row['Gerber层名']) {
                  row['层名'] = row['Gerber层名']
                }
              });
            }
          });
        }

        this.tableDataList.push(item);
      }

      this.tableKey += 1
    },

    handleEdit(row) {
      row.editData = {...row};
      row.isEditing = true;
    },

    async handleConfirm(row) {
      Object.assign(row, row.editData);
      row.isEditing = false;
      row.editData = null;
      ElMessage.success("修改成功");
      console.log("table this.fileInfo", this.fileInfo);
      await store.dispatch("fileCheckListLevelChange")
    },

    handleCancel(row) {
      row.isEditing = false;
      row.editData = null;
    },

    async handleLocate(row) {
      console.log(`准备定位表格行:`, row);
      await locationByPathKeyword(this.fileInfo.file_path, row.keyword)
    }
  }
};
</script>